import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => {
    return localStorage.getItem('tapisstore_admin_token');
  });
  const [adminEmail, setAdminEmail] = useState(() => {
    return localStorage.getItem('tapisstore_admin_email');
  });

  const login = (newToken, email) => {
    setToken(newToken);
    setAdminEmail(email);
    localStorage.setItem('tapisstore_admin_token', newToken);
    localStorage.setItem('tapisstore_admin_email', email);
  };

  const logout = () => {
    setToken(null);
    setAdminEmail(null);
    localStorage.removeItem('tapisstore_admin_token');
    localStorage.removeItem('tapisstore_admin_email');
  };

  const isAuthenticated = !!token;

  return (
    <AuthContext.Provider value={{
      token,
      adminEmail,
      isAuthenticated,
      login,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};
